export const isBFSale = (): boolean => {
  return true;
};
